import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const MessageFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M4.34 5.38H19.66L12 11.68L4.34 5.38ZM20.28 6.94V18.54H3.72V6.94L12 13.76L20.28 6.94Z" />
    </SvgIcon>
  );
});
